import React, { Component } from "react";
import RentCircleProduct from "../containers/ProductRent";

class ProductRent extends Component {
    queryParams = () => {
        return new URLSearchParams(this.props.location.search);
    }

    query = this.queryParams();
    render() {
        return (
            <section className="gray-bg product-rent-wrapper">
                <div className="main-container">
                    <RentCircleProduct successUrl={this.query.get('success_url')} circleId={this.props.match.params.circleId} />
                </div>
            </section>
        )
    }
}

export default ProductRent;